export default function isIpad(ua: string) {
  if (/ipad/i.test(ua)) {
    return true;
  }

  if (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1) {
    return true;
  }

  return false;
}
